import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Pencil, Trash2, Plus } from "lucide-react";
import { Switch } from "../ui/switch";

const EMPTY = { nome: "", texto: "", detalhe: "", visivel: true };
const inputCls = "w-full rounded-xl border border-[#C8D7E4] bg-white px-4 py-3 text-sm text-[#15579A] outline-none focus:border-[#218FFF]";

const DepForm = ({ initial, onSave, onCancel }) => {
  const [d, setD] = useState(initial);
  return (
    <form onSubmit={(e) => { e.preventDefault(); onSave(d); }} className="space-y-3 rounded-[20px] border border-[#218FFF] bg-white p-5" data-testid="admin-testimonial-form">
      <input className={inputCls} placeholder="Nome do cliente" value={d.nome} required minLength={2}
        onChange={(e) => setD({ ...d, nome: e.target.value })} data-testid="admin-testimonial-input-nome" />
      <input className={inputCls} placeholder="Detalhe (opcional, ex.: comprou carta de imóvel)" value={d.detalhe || ""}
        onChange={(e) => setD({ ...d, detalhe: e.target.value })} data-testid="admin-testimonial-input-detalhe" />
      <textarea className={inputCls} rows={3} placeholder="Depoimento" value={d.texto} required minLength={5} maxLength={800}
        onChange={(e) => setD({ ...d, texto: e.target.value })} data-testid="admin-testimonial-input-texto" />
      <div className="flex gap-2">
        <button type="submit" className="rounded-full bg-[#196ABC] px-5 py-2 text-sm font-semibold text-[#F7F5F0] hover:bg-[#218FFF]" data-testid="admin-testimonial-save-btn">Salvar</button>
        <button type="button" onClick={onCancel} className="rounded-full px-5 py-2 text-sm font-semibold text-[#15579A]" data-testid="admin-testimonial-cancel-btn">Cancelar</button>
      </div>
    </form>
  );
};

export const TestimonialsTab = ({ api }) => {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);

  const load = () => api("get", "/admin/depoimentos").then(setItems).catch(() => toast.error("Erro ao carregar"));
  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const save = async (d) => {
    const body = { nome: d.nome, texto: d.texto, detalhe: d.detalhe || null, visivel: d.visivel };
    if (d.id) await api("put", `/admin/depoimentos/${d.id}`, body);
    else await api("post", "/admin/depoimentos", body);
    setEditing(null); toast.success("Depoimento salvo"); load();
  };
  const remove = async (id) => {
    if (!window.confirm("Excluir este depoimento?")) return;
    await api("delete", `/admin/depoimentos/${id}`); toast.success("Excluído"); load();
  };

  return (
    <div className="space-y-3">
      <p className="text-sm text-[#15579A]/70">O site mostra até 3 depoimentos visíveis (os mais recentes). Sem depoimentos visíveis, a seção fica oculta.</p>
      {editing === "new" ? <DepForm initial={EMPTY} onSave={save} onCancel={() => setEditing(null)} /> : (
        <button onClick={() => setEditing("new")} data-testid="admin-testimonial-add-btn"
          className="inline-flex items-center gap-2 rounded-full bg-[#196ABC] px-5 py-2.5 text-sm font-semibold text-[#F7F5F0] hover:bg-[#218FFF]">
          <Plus className="h-4 w-4" /> Novo depoimento
        </button>
      )}
      {items.map((d) => editing === d.id ? <DepForm key={d.id} initial={d} onSave={save} onCancel={() => setEditing(null)} /> : (
        <div key={d.id} className="flex items-start gap-4 rounded-[20px] border border-[#C8D7E4] bg-white p-5" data-testid={`admin-testimonial-row-${d.id}`}>
          <div className="flex-1">
            <p className="font-serif text-lg italic text-[#15579A]">“{d.texto}”</p>
            <p className="mt-2 text-sm font-bold text-[#196ABC]">{d.nome}{d.detalhe && <span className="font-normal text-[#15579A]/70"> · {d.detalhe}</span>}</p>
          </div>
          <Switch checked={d.visivel} onCheckedChange={(v) => save({ ...d, visivel: v })} data-testid={`admin-testimonial-visible-${d.id}`} />
          <button onClick={() => setEditing(d.id)} aria-label="Editar" data-testid={`admin-testimonial-edit-${d.id}`}><Pencil className="h-4 w-4 text-[#196ABC]" /></button>
          <button onClick={() => remove(d.id)} aria-label="Excluir" data-testid={`admin-testimonial-delete-${d.id}`}><Trash2 className="h-4 w-4 text-red-600" /></button>
        </div>
      ))}
    </div>
  );
};
